import React from "react";

const Curations = () => {
  return <div>curations</div>;
};

export default Curations;
